export default __webpack_public_path__ + "img/69c2c546056ef4fe3eafcac4d4f4eb68.png";